
import React, { useState } from 'react';
import { FileText, Archive as ArchiveIcon, Calendar, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Meeting } from '../types';

const Archive: React.FC = () => {
  const [archivedMeetings] = useState<Meeting[]>(() => {
    const saved = localStorage.getItem('smsa_meetings');
    const all = saved ? JSON.parse(saved) : [];
    return all.filter((m: any) => m.status === 'ARCHIVED');
  });

  return (
    <div className="p-8 max-w-7xl mx-auto">
      <header className="mb-8">
        <h1 className="text-3xl font-bold text-slate-900 mb-2">Meeting Archive</h1>
        <p className="text-slate-500 font-medium">Historical records and final resolutions for completed sessions.</p>
      </header>

      {archivedMeetings.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {archivedMeetings.map((meeting) => (
            <div key={meeting.id} className="bg-white border border-slate-200 rounded-3xl p-6 shadow-sm hover:shadow-md transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2 bg-slate-100 text-slate-500 rounded-xl">
                  <ArchiveIcon size={20} />
                </div>
                <span className="text-[10px] font-black bg-slate-800 text-white px-2 py-0.5 rounded uppercase">Closed</span>
              </div>
              
              <h3 className="text-lg font-bold text-slate-900 mb-1 group-hover:text-indigo-600 transition-colors">{meeting.name}</h3>
              <div className="flex items-center gap-2 text-xs text-slate-400 font-bold uppercase tracking-wider mb-6">
                <Calendar size={14} /> {meeting.date}
              </div>

              <Link 
                to={`/meeting/${meeting.id}`}
                className="w-full py-3 bg-slate-50 text-slate-600 rounded-xl font-bold flex items-center justify-center gap-2 hover:bg-indigo-50 hover:text-indigo-600 transition-all text-sm"
              >
                Review Results
                <ArrowRight size={16} />
              </Link>
            </div>
          ))}
        </div>
      ) : (
        <div className="bg-white border-2 border-dashed border-slate-200 rounded-3xl p-20 flex flex-col items-center justify-center text-center">
          <div className="bg-slate-50 p-6 rounded-3xl mb-4 text-slate-200">
            <ArchiveIcon size={64} />
          </div>
          <h3 className="text-xl font-bold text-slate-800 mb-2">Archive Empty</h3>
          <p className="text-slate-500 max-w-sm font-medium">As new assemblies are completed and closed, their finalized records and voting transcripts will appear here automatically.</p>
        </div>
      )}
    </div>
  );
};

export default Archive;
